import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ParallaxProvider } from 'react-scroll-parallax';

// Get the root DOM node to mount the React application
const root = ReactDOM.createRoot(document.getElementById('root'));

// Rendering the React application
root.render(
  <React.StrictMode>
    <ParallaxProvider>
      {/* Main App component */}
      <App />
    </ParallaxProvider>
  </React.StrictMode>
);
